export default __webpack_public_path__ + "static/media/FAQs.2cb2b971.png";